
/**
* @param variants
*/
function prepare_variants(variants) {
  var variations = [];
  variants.each(function () {
    variations.push($(this).val());
  });
  return variations;
}
/**
*
*/
function get_variation(all_variants, options) {
  var variations = [];
  options = options.join(',').replace(/"/g, '\\"').replace(/'/g, "\\'");
  variations = $(all_variants).find('option[data-options="' + options + '"]');
  if (variations.length > 0)
    $(all_variants).val(variations.val()).trigger('change');
}
/**
* Check this function
*/
function filter_variants(Product, options, option_current, swatch_index, enable_atc_button) {
  var swatch_type = $('.swatch-type[data-index="' + (swatch_index + 1) + '"]');
  if (typeof Product.variations[option_current] !== 'undefined') {
    change_swatch_variants(swatch_type, Object.keys(Product.variations[option_current]), enable_atc_button);
  } else if (typeof Product.variations[options[0]] !== 'undefined' && typeof Product.variations[options[0]][option_current] !== 'undefined') {
    change_swatch_variants(swatch_type, Product.variations[options[0]][option_current], enable_atc_button);
  }
}
/**
*
*/
function change_swatch_variants(swatch, variants, enable_atc_button) {
  var first_select_value,
    swatch_select = swatch.find('.product-variant option'),
    swatch_radio = swatch.find('.swatch-variant-value');
  $('.product-variant', swatch).prop('disabled', false);
  swatch_radio.parent().addClass('swatch-disabled');
  // BEGIN_TAG_SELECT
  swatch_select.prop({
    disabled: true,
    checked: false
  });
  swatch_select.each(function () {
    if (variants.indexOf($(this).val()) > -1) {
      $(this).prop('disabled', false);
    }
  });
  first_select_value = swatch_select.filter(':not(:disabled):first').val();
  if (enable_atc_button)
    swatch_select.parent().val(first_select_value).trigger('change');
  // END_TAG_SELECT
  // BEGIN_RADIO_BUTTON
  swatch_radio.prop({
    disabled: true,
    checked: false
  });
  swatch_radio.each(function (i) {
    if (variants.indexOf($(this).val()) > -1) {
      $(this).prop('disabled', false);
      $(this).parent().removeClass('swatch-disabled');
    }
  });
  if (enable_atc_button)
    swatch_radio.filter(':not(:disabled):first').trigger('click');
  // END_RADIO_BUTTON
  swatch.prev().find('.choose-option').removeClass('choose-option');
}
function choose_before_option(i) {
  $('.swatch-type[data-index="' + i + '"] .swatch-element').on('click', function () {
    var swatch_checkeds = $('.swatch-type[data-index="' + (i - 1) + '"] input:checked').length;
    var swatch_selects = typeof $('.swatch-type[data-index="' + (i - 1) + '"] select').val() !== 'undefined' && $('.swatch-type[data-index="' + (i - 1) + '"] select').val() !== '';
    $('.swatch-type.swatch-elements-wrapper').removeClass('choose-option');
    if (swatch_checkeds === 0 && swatch_selects === false) {
      $('.swatch-type[data-index="' + (i - 1) + '"] .swatch-elements-wrapper').addClass('choose-option');
    }
  });
}
function you_save(compare_at_price, price) {
  let value = 100 - ((price * 100) / compare_at_price);
  let percent_selector = $('.compare_percent');
  let price_selector = $('.you-save-price .money');
  let you_save = $('.you-save-price');
  if (compare_at_price > price) {
    percent_selector.html(" (" + value.toFixed(2) + "%)");
    price_selector.html(Shopify.formatMoney(compare_at_price - price));
    you_save.fadeIn(function () { you_save.show(); });
  } else {
    you_save.fadeOut(function () { you_save.hide(); });
  }
}
var _quantity = $('.product-form-buttons-wrapper .quantity'),
  _product_featured = $('.jq-featured-slider'),
  _add_to_cart_value = $('.btn-add-tocart > .btn-money'),
  _add_to_cart_items = $('.btn-add-tocart > .btn-items'),
  _product_options = $('.jq-swatch-element,.jq-product-variant'),
  _current_price = $('.product-price .current-price'),
  _current_compare_price = $('.product-price .compare-price'),
  _choosed_variant = $('.all-variant'),
  _price = $(':selected', _choosed_variant).attr('data-price'),
  _global_variant_compare_at_price = $(':selected', $('.all-variant')).attr('data-compare-at-price') === "" ? "" : Shopify.formatMoney($(':selected', $('.all-variant')).attr('data-compare-at-price'));

// Product Options
_product_options.change(function () {
  var options = prepare_variants($('.jq-product-variant option:selected,.swatch-variant-value:checked'));
  
  get_variation(_choosed_variant, options);
  $(this).parent().removeClass('choose-option');
  
  // Filter Variants
  filter_variants(VastaShop.Product.current, options, $(this).val(), parseInt($(this).attr('data-swatch-index')), (options.length == VastaShop.Product.current.options.length));
  
  if (options.length === VastaShop.Product.current.options.length) {
    $('.btn-add-tocart').prop('disabled', false);
    $('.product-form-buttons-wrapper,.btn-add-tocart').removeClass('hide');
    $('.btn-choose-variant').addClass('hide');
    enableInputs($('.all-variant option:selected').val());
    if (parseInt(VastaShop.Variables._input_qtd.val()) == 1) {
      VastaShop.Variables._bt_minus.attr('disabled', 'disabled');
    }
  }
  
  if (typeof extendedSwatch === 'function' && typeof allVariants !== 'undefined') {
    // init code
    try {
      const selectedVariant = extendedSwatch(allVariants);
 
      if (!selectedVariant) {
        throw new Error('Variant does not exist.');
      }

      let price = 0;
      let comparePrice = 0;
      let variantOption = '';
      let variantOption2 = '';
      let counter = 0;
      let available = false;
      let featured_imagePosition = 0;
      let idUrl = '';
      let handle = '';

      if(selectedVariant && Array.isArray(selectedVariant)){
        selectedVariant.forEach((variant)=>{
            price += variant.price;
            comparePrice += variant.compare_at_price;
            variantOption = variant.option1;
            variantOption2 = variant.option2;
            featured_imagePosition = variant.featured_image.position;
            handle = variant.handle;
            if(variant.available){
              idUrl += variant.id; 
              if(counter == 0){
                idUrl += '-';
              }
              counter++;
              available = (counter == 2) ? true : false;
            }
        });
      } else {
        price += selectedVariant.price;
        comparePrice += selectedVariant.compare_at_price;
        variantOption = selectedVariant.option1;
        variantOption2 = selectedVariant.option2;
        featured_imagePosition = selectedVariant.featured_image.position;
        idUrl = selectedVariant.id;
        available = selectedVariant.available;
        handle = selectedVariant.handle;
      }

      // Change the price
      const numericPrice = parseFloat(Shopify.formatMoney(price, '\{\{ amount \}\}'));
      const discountedPrice = (numericPrice * 0.9).toFixed(2);
      const newPriceHTML = selectedVariant.length > 1 ? `
        <span class="compare-price">${Shopify.formatMoney(price)}</span>
        <span class="discounted-price">${'$' + discountedPrice}</span>
      ` : `${Shopify.formatMoney(price)}`;
      $('.new-product-price-value').html(newPriceHTML);

      const quantity = parseInt($('#ProductQuantity') || 1);
      $('.btn-add-tocart .btn-money').html(Shopify.formatMoney(price * quantity));

      // Show/Hide compare if it there is.
      if (comparePrice) {
        $('.new-price-discounts-wrapper .compare-price')
          .html(Shopify.formatMoney(comparePrice))
          .show();
      } else {
        $('.new-price-discounts-wrapper .compare-price').empty().hide();
      }

      /* Set SKU */
      setSKU(selectedVariant);

      const isNeopreme = /Black Diamond/i.test(variantOption)

      if (available) {
        $('#AddToCart').show();
        $('#button-out-of-stock').hide();
      } else {
        $('#AddToCart').hide();
        $('#button-out-of-stock').show();
      }


      if (handle !== undefined)  { 
        const url = new URL(window.location.href);
        url.pathname = url.pathname.replace(/\/products(.*)/gi, '/products/') + handle;
        
        Shopify.replaceState(url.pathname); 
        Shopify.setParam('variant', idUrl);
      }

      const atcPrice = price * parseInt($('[name="quantity"]').val() || 1);
      _add_to_cart_value.html(Shopify.formatMoney(atcPrice));

      $('.jq-featured-slider').slick('slickGoTo', Math.max(featured_imagePosition - 1, 0));

      Shopify.replaceState(Shopify.newState('variant', idUrl));

      $('[class*="image-text__filter--"]').hide();

      if (typeof selectedVariant !== 'undefined') {
        // Change Seat Cover Material description
        if (/1000 denier cordura/gi.test(variantOption)) {
          $('#cordura-seat-cover-desctiption').show().siblings().hide();
          $('.image-text__filter--1000d-cordura').show();
          getTrustBadges('/products/1000-denier-cordura-canvas')
        } else if (/x\-factor/gi.test(variantOption)) {
          $('#x-factor-seat-cover-desctiption').show().siblings().hide();
          $('.image-text__filter--x-factor').show();
          getTrustBadges('/products/x-factor-synthetic-leather')
        } else if (/black diamond/gi.test(variantOption)) {
          $('#black-diamond-seat-cover-desctiption').show().siblings().hide();
          $('.image-text__filter--black-diamond').show();
          getTrustBadges('/products/black-diamond-genuine-neoprene')
        } else if (/truetimber/gi.test(variantOption)) {
          $('#truetimber-seat-cover-desctiption').show().siblings().hide();
          $('.image-text__filter--truetimber').show();
          getTrustBadges('/products/truetimber-canvas')
        }
    
        $('.seat-covers--selected').html(variantOption);
        $('.seat-covers--color').html(variantOption2);

        // const $link = $('.other-truck__link');
            
        // if (/1000 denier cordura/gi.test(variantOption)) {
        //   $link.attr('href', '/products/1000-denier-cordura-canvas');
        // } else if (/x\-factor/gi.test(variantOption)) {
        //   $link.attr('href', '/products/x-factor-synthetic-leather');
        // } else if (/black diamond/gi.test(variantOption)) {
        //   $link.attr('href', '/products/black-diamond-genuine-neoprene');
        // } else if (/truetimber/gi.test(variantOption)) {
        //   $link.attr('href', '/products/truetimber-canvas');
        // }
      }
    } catch (err) {
      console.log(err);
    }
    // end code
  }

  return false;
});





// Choosed Variant

_choosed_variant.change(function () {
  var variant_id = $(':selected', this).val();
  var variant_price = $(':selected', this).attr('data-price');
  var variant_inventory = parseInt($(':selected', this).attr('data-inventory'));
  var variant_available = $(':selected', this).attr('data-available');
  var variant_compare_at_price = $(':selected', this).attr('data-compare-at-price') === "" ? "" : Shopify.formatMoney(parseInt($(':selected', this).attr('data-compare-at-price')), Shopify.money_format);
  var compare_at_price = $(':selected', this).attr('data-compare-at-price') === "" ? "" : parseInt($(':selected', this).attr('data-compare-at-price'));
  var variant_image_position = $(':selected', this).attr('data-image-position');

  _quantity.val(1);

  if (variant_image_position) {
    variant_image_position = Math.max(parseInt(variant_image_position) - 1, 0);

    if (slideCounter > 0) {
      _product_featured.slick('slickGoTo', variant_image_position || 0);
    } else {
      setTimeout(function(){
        _product_featured.slick('slickGoTo', variant_image_position || 0);
        slideCounter++;
      },600);
    }
  }

  const newPrice = Shopify.formatMoney(variant_price);
  
  variant_price = parseInt(variant_price);
  compare_at_price = parseInt(compare_at_price !== '' ? compare_at_price : 0);

  _current_price.html(newPrice);
  
  $('.jq-new-price').html(newPrice.toString().replace(/[^0-9,.]/gi, ''))
  
  _current_compare_price.html(variant_compare_at_price);
  
  $('.jq-new-compare-price').html(variant_compare_at_price)

  if (variant_price < compare_at_price) {
    _current_compare_price.show();
  } else {
    _current_compare_price.hide();
  }
  
  _price = $(':selected', _choosed_variant).attr('data-price');
  _add_to_cart_value.html(Shopify.formatMoney(parseInt(_quantity.val()) * _price));
  _quantity.attr('data-max', variant_inventory);
  inventoryControl(variant_id);
  enableInputs(variant_id);
  
  if (parseInt(_quantity.val()) == 1) {
    _quantity.siblings('.btn-minus').attr('disabled', 'disabled');
  }
  
  quantity = parseInt($('#ProductQuantity').val());
  price = parseInt($('.product-variant[name="id"] option:selected').data('price'));
  you_save(compare_at_price, parseInt(variant_price));
  
  if (quantity > 1) {
    $(_add_to_cart_items).html(quantity + " ITEMS")
  } else {
    $(_add_to_cart_items).html(quantity + " ITEM")
  }
  
  if ('true' === variant_available) {
    $('.product-quantity,#AddToCart').show();
    $('#button-out-of-stock').hide();
  } else {
    $('.product-quantity,#AddToCart').hide();
    $('#button-out-of-stock').show();
  }
  
  Shopify.replaceState(Shopify.newState('variant', variant_id));

  // Seat Cover Material
  $('[class*="image-text__filter--"]').hide();

  let variants = VastaShop.Product.current.variants;

  if (typeof allVariants !== 'undefined') {
    variants = allVariants;
  }

  const variant = variants.find(function(v){
    return v.id == variant_id;
  });
  
  if (typeof variant !== 'undefined') {
    // Change Seat Cover Material description
    if (/1000 denier cordura/gi.test(variant.option1)) {
      $('#cordura-seat-cover-desctiption').show().siblings().hide();
      $('.image-text__filter--1000d-cordura').show();
    } else if (/x\-factor/gi.test(variant.option1)) {
      $('#x-factor-seat-cover-desctiption').show().siblings().hide();
      $('.image-text__filter--x-factor').show();
    } else if (/black diamond/gi.test(variant.option1)) {
      $('#black-diamond-seat-cover-desctiption').show().siblings().hide();
      $('.image-text__filter--black-diamond').show();
    } else if (/truetimber/gi.test(variant.option1)) {
      $('#truetimber-seat-cover-desctiption').show().siblings().hide();
      $('.image-text__filter--truetimber').show();
    }

    $('.seat-covers--selected').html(variant.option1);
    $('.seat-covers--color').html(variant.option2);
  }

  if (typeof extendedSwatch === 'function') {
    // init code
    try {
      const selectedVariant = extendedSwatch(variants);

      if (!selectedVariant) {
        throw new Error('Variant does not exist.');
      }

      // Change the price
      $('.new-product-price-value').html('');

      const quantity = parseInt($('#ProductQuantity') || 1);
      $('.btn-add-tocart .btn-money').html(Shopify.formatMoney(selectedVariant.price * quantity));

      // Show/Hide compare if it there is.
      if (selectedVariant.compare_at_price) {
        $('.new-price-discounts-wrapper .compare-price')
          .html(Shopify.formatMoney(selectedVariant.compare_at_price))
          .show();
      } else {
        $('.new-price-discounts-wrapper .compare-price').empty().hide();
      }

      /* Set SKU */
      setSKU(selectedVariant);

      if (selectedVariant.available) {
        $('#AddToCart').show();
        $('#button-out-of-stock').hide();
      } else {
        $('#AddToCart').hide();
        $('#button-out-of-stock').show();
      }

      if (selectedVariant.handle !== undefined) {
        const url = new URL(window.location.href);
        
        url.pathname = url.pathname.replace(/\/products(.*)/gi, '/products/') + selectedVariant.handle;
        
        Shopify.replaceState(url.pathname);
        Shopify.setParam('variant', selectedVariant.id);
      }

      const atcPrice = selectedVariant.price * parseInt($('[name="quantity"]').val() || 1);
      _add_to_cart_value.html(Shopify.formatMoney(atcPrice));
    } catch (err) {
      console.log(err);
    }
    // end code
  }
});

$(document).ready(function () {
  $('.swatch-type[data-index="1"] .swatch-element').each(function () {
    if (Object.keys(VastaShop.Product.current.variations).indexOf($(this).attr('data-swatch')) > -1) {
      $(this).removeClass('swatch-disabled').find('input').prop('disabled', false);
    } else {
      $(this).find(".tooltip").remove();
    }
  });
  $('.swatch-type[data-index="1"] .jq-product-variant option').each(function () {
    if (Object.keys(VastaShop.Product.current.variations).indexOf($(this).attr('value')) < 0 && $(this).attr('value') !== '') {
      $(this).prop('disabled', true);
    }
  });

  // Check First Options in Swatch Material/Color
  if (VastaShop.Product.options.length > 0) {
    const materialLocalStorage = localStorage.getItem("__material_selected");
    VastaShop.Product.options.forEach(function (option) {
      let selectThisSwatchMaterialAndColor = option.replace(/"/g, '\\"').replace(/'/g, "\\'");
      const materialLocalStorage = localStorage.getItem("__material_selected");

      if(materialLocalStorage){
        const swatchMaterial = document.querySelectorAll('.swatch-type[data-type="Select The Material"] .swatch-element-standard .swatch-variant-value');
        swatchMaterial.forEach((swatch)=>{
          if(swatch.value == materialLocalStorage) { 
            swatch.click();
            const swatchColor = $('.swatch-type[data-type="Select The Color"] .swatch-element-color:not(.swatch-disabled) .swatch-variant-value');
            $(swatchColor[0]).prop("checked", true);
            $('.product-variant option[value="' + selectThisSwatchMaterialAndColor + '"]').parent().val(selectThisSwatchMaterialAndColor.replace(/\\/gi, '')).trigger('change');
            $(swatchColor[0]).trigger('change');
          }
        });
      } else {
        $('.swatch-element[data-swatch="' + selectThisSwatchMaterialAndColor + '"]').trigger('click');
        $('.product-variant option[value="' + selectThisSwatchMaterialAndColor + '"]').parent().val(selectThisSwatchMaterialAndColor.replace(/\\/gi, '')).trigger('change');
      }    
    });

    const templateProduct = $('.template-product.material');
    
    if(!templateProduct){
      const colorSelected = $('.swatch-type[data-type="Select The Color"] .swatch-element-color:not(.swatch-disabled) .swatch-variant-value:checked').val();
      $('.product-title').html(materialLocalStorage + ' - ' + colorSelected ? colorSelected : 'Black');
    }; 
  }

  if (prepare_variants($('.swatch-variant-value:checked', $('.swatch-element'))).length == VastaShop.Product.current.options.length) {
    _current_price.html(Shopify.formatMoney($(':selected', _choosed_variant).attr('data-price')));
    _current_compare_price.html(_global_variant_compare_at_price);
    _add_to_cart_value.html(Shopify.formatMoney(parseInt(_quantity.val()) * _price));
  }
  $('.modal-close').click(function () {
    $('.modal-container').removeClass('active');
  });
  $(window).click(function (e) {
    if (e.target == $('.modal-container').get(0))
      $('.modal-container').removeClass('active');
  });
  for (var i = 2, j = VastaShop.Product.current.options.length + 1; i < j; i++) {
    choose_before_option(i);
  }
});